export default function determineIfNewApi(projectId: number): boolean {

    const newApiProjectIds = [1, 69, 21, 12, 51, 32, 30, 18, 17, 40, 26];
    return newApiProjectIds.includes(projectId);
}